export const Logo = ({ size = 44 }) => (
  <span className="cactus-logo" style={{ height: size }} aria-label="Cactus Design Studio">
    <img
      className="cactus-logo-img cactus-logo-img--light-bg"
      src="/cactus-logo-01.png"
      alt="Cactus"
      height={size}
    />
    <img
      className="cactus-logo-img cactus-logo-img--dark-bg"
      src="/cactus-logo-02.png"
      alt="Cactus"
      height={size}
    />
  </span>
);
